import { Grid, Typography, TextField, FormControl, Fab } from "@material-ui/core";
import { useEffect, useState } from "react";
import { ErrorMessage, Field, FieldProps, Form, Formik } from "formik";
import * as Yup from "yup"
import { useSnackBar } from "../../../../SnackBarContext/SnackBarContext";
import { IAddress } from "../../../../../reducers/bookings/types";
import React from "react";
import _ from "lodash";
import FlatPickerBar from "../../../../FlatPicker";
import { DateTime as d } from "luxon"
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { getDefaultCountryCode, getLocalisedLicense, getLocalizedDateFormat } from "../../../../../utils/localized.syntex";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import AddressPicker from "../../../../AddressPicker/AddressPicker";
import { SnackBarVariant } from "../../../../SnackbarWrapper/SnackbarWrapper";
import { DragDropImages } from "../../../CustomerPortal/Vehicle/DragDropImages";
import { buildFieldRequiredMap, buildFieldVisibilityMap, DATE_TYPE, defaultWebsiteIndividualFields, formatGraphQLErrorMessage, getUploadedImageByKey, returnfileContentTypeAndExtention } from "../../../../utils";
import * as UUID from "uuid";
import { IAppState } from "../../../../../store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { ApolloError, useLazyQuery } from "@apollo/client";
import { GET_CUSTOM_FORM_BY_TYPE } from "../../../../../graphql/customers/getConsumerCustomForm";
import { TranslationKeys } from "../../../../../utils/translations/types";
export interface IDriverRow {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  license: {
    authority: string;
    licenseNumber: string;
    dateOfExpiry: string;
    images: (string | object | undefined)[];
  };
  phoneNumber: {
    phone: string;
    country: string;
  };
  location: IAddress;
  nationalInsuranceNumber?: string;
  profession?: string;
  verificationMethod?: string;
}
interface INewDrivers {
  drivers: IDriverRow[]
}

export const defaultValues: IDriverRow = {
  firstName: "",
  lastName: "",
  email: "",
  license: {
    authority: "",
    licenseNumber: "",
    dateOfExpiry: "",
    images: []
  },
  phoneNumber: {
    phone: "",
    country: ""
  },
  location: {
    city: "",
    country: "",
    fullAddress: "",
    state: "",
    street: "",
    zipcode: ""
  },
}

interface IAddDriversProps {
  saveDriverLoading: boolean;
  handleSubmit: (data: IDriverRow) => void;
  openForm: () => void;
  selectedDriver: IDriverRow | null
}

const StyledInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      // marginBottom: 20,
      '& .MuiOutlinedInput-input': {
        padding: '14px 14px'
      },
      '& .MuiOutlinedInput-multiline': {
        padding: '0px 4px'
      },
      '& .MuiOutlinedInput-root fieldset': {
        borderColor: '#e2e2e2',
        borderRadius: 8
      },
      '& .MuiSelect-select:focus': {
        backgroundColor: 'transparent'
      },
      '& .MuiSelect-select': {
        padding: '10px 14px'
      },
      '& .MuiSelect-select ~ fieldset': {
        border: 0
      },
    },
  }),
)(TextField);

const AddNewDriver: React.FC<IAddDriversProps> = (props) => {

  const website = useSelector(
    (state: IAppState) => state.consumerWebsiteReducer.consumerWebsite
  );
  const { country } = website.organisation.address;
  const organisationData = useSelector((state: IAppState) => state.consumerWebsiteReducer.consumerWebsite.organisation);

  const snackbar = useSnackBar();
  const [newDriver, setNewDriver] = useState<IDriverRow>(_.cloneDeep(defaultValues));
  const [phoneError, setPhoneError] = useState<string>("");
  const [countryCode, setCountryCode] = useState<any>(getDefaultCountryCode('United Kingdom'));
  const [documentDialogVisible, setDocumentDialogVisible] = useState<boolean>(
    false
  );
  const [uploadInProgress, setUploadInProgress] = useState<boolean>(false);
  const { _e_ } = useSelector((state: IAppState) => state.authReducer);
  const { t } = useTranslation();
  const [requiredMap, setRequiredMap] = useState<Record<string, boolean>>(
    buildFieldRequiredMap(defaultWebsiteIndividualFields)
  );
  const [visibilityMap, setVisibilityMap] = useState<Record<string, boolean>>(
    buildFieldVisibilityMap(defaultWebsiteIndividualFields)
  );

  const [getCustomFormByType] = useLazyQuery(GET_CUSTOM_FORM_BY_TYPE, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {

      if (data?.getConsumerCustomFormType?.config?.website?.fields.length) {
        const customMap = buildFieldRequiredMap(data.getConsumerCustomFormType.config.website.fields);
        const customVisibilityMap = buildFieldVisibilityMap(data.getConsumerCustomFormType.config.website.fields);
        setRequiredMap(customMap);
        setVisibilityMap(customVisibilityMap);
      } else {
        const defaultMap = buildFieldRequiredMap(defaultWebsiteIndividualFields);
        const defaultVisibilityMap = buildFieldVisibilityMap(defaultWebsiteIndividualFields);
        setRequiredMap(defaultMap);
        setVisibilityMap(defaultVisibilityMap);
      }
    },
    onError: (error: ApolloError) => {
      snackbar({
        message: formatGraphQLErrorMessage(error.message),
        variant: SnackBarVariant.ERROR
      });
      const defaultMap = buildFieldRequiredMap(defaultWebsiteIndividualFields);
      const defaultVisibilityMap = buildFieldVisibilityMap(defaultWebsiteIndividualFields);
      setRequiredMap(defaultMap);
      setVisibilityMap(defaultVisibilityMap);
    }
  });

  useEffect(() => {
    getCustomFormByType({
      variables: {
        organisationId: organisationData.id,
        formType: "INDIVIDUAL",
        atBranchLevel: false
      }
    })
  }, [])

  useEffect(() => {
    if (props && props.selectedDriver) {
      setNewDriver(props.selectedDriver)
    }
  }, [props.selectedDriver])

  const createDynamicApprovedDriverSchema = (
    requiredMap: Record<string, boolean>,
    t: (key: string, options?: Record<string, any>) => string
  ) => {
    const getLabel = (labelKey: string) => t(labelKey) ?? labelKey;

    const createConditionalString = (
      key: string,
      errorKey: TranslationKeys,
      interpolationValues?: Record<string, string | number>
    ) =>
      requiredMap[key]
        ? interpolationValues
          ? Yup.string().required(t(errorKey, { ...interpolationValues }))
          : Yup.string().required(t(errorKey))
        : Yup.string();

    const createConditionalEmail = (fieldKey: string, labelKey: string) => {
      const base = Yup.string().email(t("validation:pleaseEnterAValidEmail", { field: getLabel(labelKey) }));
      return requiredMap[fieldKey]
        ? base.required(t("validation:emailIsRequired", { field: getLabel(labelKey) }))
        : base;
    };

    const createConditionalPhone = (fieldKey: string, labelKey: string) => {
      const base = Yup.string().test("is-valid-phone", t("root:invalidPhoneNumber"), (value) => {
        if (!value) return true;
        return isValidPhoneNumber(value);
      });

      return requiredMap[fieldKey]
        ? base.required(t("validation:phoneNumberRequired", { field: getLabel(labelKey) }))
        : base;
    };

    const createAddressSchema = (fieldKey: string, labelKey: string) => {
      if (!requiredMap[fieldKey]) {
        return Yup.object().shape({
          fullAddress: Yup.string(),
          country: Yup.string(),
          state: Yup.string(),
          city: Yup.string(),
          street: Yup.string(),
          zipcode: Yup.string(),
        });
      }

      return Yup.object()
        .shape({
          fullAddress: Yup.string().required(t("validation:required", { field: t("root:address") })),
          country: Yup.string().required(t("validation:required", { field: t("root:country") })),
          state: Yup.string().required(t("validation:required", { field: t("root:state") })),
          city: Yup.string().required(t("validation:required", { field: t("root:city") })),
          street: Yup.string().required(t("validation:required", { field: t("root:street") })),
          zipcode: Yup.string(),
        })
        .required(t("validation:required", { field: getLabel(labelKey) }));
    };

    return Yup.object().shape({
      firstName: createConditionalString("firstName", "validation:firstNameRequired"),
      lastName: createConditionalString("lastName", "validation:lastNameRequired"),

      email: createConditionalEmail("email", "root:emailAddress"),

      phoneNumber: Yup.object().shape({
        phone: createConditionalPhone("phoneNumber", "root:phoneNumber"),
        country: Yup.string(),
      }),

      location: createAddressSchema("location", "root:location"),
      license: Yup.object().shape({
        licenseNumber: createConditionalString(
          "licenseNumber",
          "validation:licenceNumberRequired",
          { licenceSyntax: getLocalisedLicense(country) }
        ),
        authority: createConditionalString("authority", "validation:authorityRequired"),
      }),
    });
  };

  const driverSchema = createDynamicApprovedDriverSchema(requiredMap, t);

  const uploadDocument = async (files: File[]) => {
    try {
      if (uploadInProgress) {
        return snackbar({
          message: t("snackBar:imageUploadInProgress"),
          variant: SnackBarVariant.ERROR
        });
      }
      const licenceImageArray: any[] = [];
      const showUploadedDriverImages: any[] = [];
      const item = newDriver.license;
      if (item && item.images && item.images.length >= 2) {
        return snackbar({
          message: `${t("snackBar:maximumTwoImage")} ${getLocalisedLicense(country)}!`,
          variant: SnackBarVariant.ERROR
        });
      }
      for (let index = 0; index < files.length; index++) {
        const file = files[index];
        if (file.size > 52428800) {
          throw new Error(t("snackBar:fileSizeExceeded50mb"));
        }
        if (file.type === "image/png" || file.type === "image/jpeg" || file.type === "image/jpg") {
          const { fileExtension } = returnfileContentTypeAndExtention(file);
          const uniqueId = UUID.v4();
          const key = `${uniqueId}.${fileExtension}`;
          if (_e_) {
            await _e_
              .add({
                name: key,
                file: file,
                complete: async () => {
                  licenceImageArray.push(key);
                  snackbar({
                    message: `${getLocalisedLicense(country)} ${t("snackBar:ImageUploaded")}`,
                    variant: SnackBarVariant.SUCCESS
                  });
                  const uploadedFile = await getUploadedImageByKey(key);
                  if (uploadedFile) {
                    showUploadedDriverImages.push(uploadedFile);
                  }
                  setUploadInProgress(false);
                  setDocumentDialogVisible(false);
                }
              });
          }
        } else {
          setDocumentDialogVisible(true);
          setUploadInProgress(false);
          setTimeout(() => {
            return snackbar({
              message: t("snackBar:uploadImageFormatError"),
              variant: SnackBarVariant.ERROR
            });
          }, 2000);
        }
      }
      item.images = [...licenceImageArray];
      setNewDriver({
        ...newDriver,
        license: item
      });
    }
    catch (err: any) {
      snackbar({
        message: formatGraphQLErrorMessage(err.message),
        variant: SnackBarVariant.ERROR
      });
    }
  }

  const onDeleteDriverImage = () => { }

  return (
    <Grid item container xs={12} style={{ padding: "20px 0" }}>
      <Formik
        initialValues={newDriver}
        enableReinitialize={true}
        validationSchema={driverSchema}
        onSubmit={(data, { setSubmitting, resetForm }) => {
          if (newDriver.license && !newDriver.license.images.length) {
            snackbar({
              message: `${t("root:atleastUploadOne")} ${getLocalisedLicense(country)} ${t("root:image")}.`,
              variant: SnackBarVariant.ERROR
            });
            setSubmitting(false);
            return;
          }
          if (requiredMap.dateOfExpiry && !newDriver.license?.dateOfExpiry) {
            snackbar({
              message: t('validation:required', {
                field: t('root:drivingLicenceExpiryDate', {
                  licenceSyntax: getLocalisedLicense(country),
                }),
              }),
              variant: SnackBarVariant.ERROR,
            });
            return;
          }
          data.license.images = newDriver.license.images;
          setNewDriver(_.cloneDeep(defaultValues))
          props.handleSubmit(data)
          resetForm();
          setSubmitting(false)
        }}
      >
        {({ values, setFieldValue, submitForm }) => (
          <Form>
            <Grid item container xs={12}>
              {visibilityMap.firstName && (
              <Grid item xs={4} style={{ paddingRight: "10px" }} >
                <Field
                  name="firstName"
                >
                  {({ field, meta: { touched, error }, }: FieldProps) => (
                    <>
                      <TextField
                        {...field}
                        error={touched && Boolean(error)}
                        placeholder={t("root:firstNameLabel")}
                        label={t("root:firstNameLabel")}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          setNewDriver({
                            ...newDriver,
                            firstName: e.target.value
                          });
                          setFieldValue("firstName", e.target.value)
                        }}
                        required={requiredMap.firstName}
                        fullWidth
                      >
                      </TextField>
                      <Typography variant="body2" color="error">{touched && Boolean(error) && error}</Typography>
                    </>
                  )}
                </Field>
              </Grid>
              )}
              {visibilityMap.lastName && (
              <Grid item xs={4} style={{ paddingRight: "10px" }} >
                <Field
                  name="lastName"
                >
                  {({ field, meta: { touched, error }, }: FieldProps) => (
                    <>
                      <TextField
                        {...field}
                        error={touched && Boolean(error)}
                        placeholder={t("root:lastNameLabel")}
                        label={t("root:lastNameLabel")}
                        onChange={(e: { target: { value: string; }; }) => {
                          setFieldValue("lastName", e.target.value)
                          setNewDriver({
                            ...newDriver,
                            lastName: e.target.value
                          });
                        }}
                        required={requiredMap.lastName}
                        fullWidth
                      ></TextField>
                      <Typography variant="body2" color="error">{touched && Boolean(error) && error}</Typography>
                    </>
                  )}
                </Field>
              </Grid>
              )}
              {visibilityMap.email && (
              <Grid item xs={4} style={{ paddingRight: "10px" }} >
                <Field
                  name="email"
                >
                  {({ field, meta: { touched, error }, }: FieldProps) => (
                    <>
                      <TextField
                        {...field}
                        error={touched && Boolean(error)}
                        placeholder={t("root:emailLabel")}
                        label={t("root:emailLabel")}
                        onChange={(e: { target: { value: string; }; }) => {
                          setFieldValue("email", e.target.value)
                          setNewDriver({
                            ...newDriver,
                            email: e.target.value
                          });
                        }}
                        fullWidth
                        required={requiredMap.email}
                      ></TextField>
                      <Typography variant="body2" color="error">{touched && Boolean(error) && error}</Typography>
                    </>
                  )}
                </Field>
              </Grid>
              )}
              {visibilityMap.licenseNumber && requiredMap.licenseNumber && (
                <Grid item xs={4} style={{ paddingRight: 10, marginTop: 20 }}>
                  <Field
                    name="license.licenseNumber"
                  >
                    {({ field, meta: { touched, error }, }: FieldProps) => (
                      <>
                        <TextField
                          {...field}
                          error={touched && Boolean(error)}
                          placeholder={`${getLocalisedLicense(country)} ${t("root:number")}`}
                          label={`${getLocalisedLicense(country)} ${t("root:number")}`}
                          onChange={(e: { target: { value: string; }; }) => {
                            setFieldValue("license.licenseNumber", e.target.value)
                            setNewDriver({
                              ...newDriver,
                              license: {
                                ...newDriver.license,
                                licenseNumber: e.target.value
                              }
                            });
                          }}
                          inputProps={{ maxLength: 20 }}
                          fullWidth
                          required={requiredMap.licenseNumber}
                        ></TextField>
                        <Typography variant="body2" color="error">{touched && Boolean(error) && error}</Typography>
                    </>
                  )}
                </Field>
              </Grid>
              )}
              {visibilityMap.dateOfExpiry && (
              <Grid item xs={4} style={{ paddingRight: 10, marginTop: 20 }}>
                <FormControl variant="outlined" fullWidth>
                  <FlatPickerBar
                    name="license.dateOfExpiry"
                    handleDateChange={(value: Date) => {
                      if (value) {
                        const dateOfExpiry = d.fromJSDate(value).toUTC().toISO();
                        setFieldValue("license.dateOfExpiry", dateOfExpiry)
                        setNewDriver({
                          ...newDriver,
                          license: {
                            ...newDriver.license,
                            dateOfExpiry: dateOfExpiry
                          }
                        });
                      }
                    }}
                    enableTime={false}
                    label={`${t("root:driving")} ${getLocalisedLicense(country)} ${t("root:expiryDate")}`}
                    identifier={"dateOfExpiry"}
                    placeholderValue={`${t("root:driving")} ${getLocalisedLicense(country)} ${t("root:expiryDate")}`}
                    value={getLocalizedDateFormat(country, values.license.dateOfExpiry, DATE_TYPE.CONDENSED)}
                    required={requiredMap.dateOfExpiry}
                    minDate={getLocalizedDateFormat(country, d.now().toUTC().toISO(), DATE_TYPE.CONDENSED)}
                    country={country}
                  />
                  <ErrorMessage
                    name={"license.dateOfExpiry"}
                    component="div"
                    className="field-error"
                  >
                    {msg => <div className={"field-error-message"}>{msg}</div>}
                  </ErrorMessage>
                </FormControl>
              </Grid>
              )}
              {visibilityMap.authority && (
              <Grid item xs={4} style={{ paddingRight: "10px", marginTop: "20px" }}>
                <Field
                  name="license.authority"
                >
                  {({ field, meta: { touched, error }, }: FieldProps) => (
                    <>
                      <TextField
                        {...field}
                        error={touched && Boolean(error)}
                        placeholder={t("root:authority")}
                        label={t("root:authority")}
                        inputProps={{ maxLength: 20 }}
                        onChange={(e: { target: { value: string; }; }) => {
                          setFieldValue("license.authority", e.target.value)
                          setNewDriver({
                            ...newDriver,
                            license: {
                              ...newDriver.license,
                              authority: e.target.value
                            }
                          });
                        }}
                        fullWidth
                        required={requiredMap.authority}
                      ></TextField>
                      <ErrorMessage
                        name="license.authority"
                        component="div"
                        className="field-error"
                      >
                        {msg => <div className={"field-error-message"}  >{msg}</div>}
                      </ErrorMessage>
                    </>
                  )}
                </Field>
              </Grid>
              )}
              {visibilityMap.phoneNumber && (
              <Grid item xs={12} sm={12} md={4} lg={6} xl={4} style={{ paddingRight: "10px", marginTop: "16px" }}>
                <Field
                  component={StyledInput}
                  name={"phoneNumber.phone"}
                  required={requiredMap.phoneNumber}
                >
                  {({ field, meta: { touched, error }, meta }: FieldProps) => {
                    return (
                      <div className={`phone-input-container`} style={{ marginTop: 9 }}>
                        <div style={{ border: `1px solid ${(touched && Boolean(error)) ? '#D13135' : '#c0c0c0'}`, borderRadius: 6 }}>
                          <PhoneInput
                            {...field}
                            international={false}
                            defaultCountry={countryCode}
                            placeholder={`${t("root:phonePlaceholder")}`}
                            className={(touched && Boolean(error)) ? "phone-input-error" : ""}
                            name={"phoneNumber.phone"}
                            value={values.phoneNumber.phone}
                            onChange={(val) => {
                              if (val && isValidPhoneNumber(val)) {
                                setPhoneError("");
                              }
                              setFieldValue("phoneNumber.phone", val)
                              setNewDriver({
                                ...newDriver,
                                phoneNumber: {
                                  ...newDriver.phoneNumber,
                                  phone: val
                                }
                              });
                            }}
                            onBlur={() => {
                              if (requiredMap.phoneNumber) {
                                if (!values.phoneNumber.phone) {
                                  setPhoneError(t("validation:phoneNumberRequired"));
                                } else if (!isValidPhoneNumber(values.phoneNumber.phone)) {
                                  setPhoneError(t("validation:enterValidPhoneNumber"));
                                } else {
                                  setPhoneError("");
                                }
                              } else {
                                if (values.phoneNumber.phone && !isValidPhoneNumber(values.phoneNumber.phone)) {
                                  setPhoneError(t("validation:enterValidPhoneNumber"));
                                } else {
                                  setPhoneError("");
                                }
                              }
                            }}
                            required={requiredMap.phoneNumber}
                            onCountryChange={(val) => {
                              setCountryCode(val);
                              if (val) {
                                setFieldValue("phoneNumber.country", val)
                                setNewDriver({
                                  ...newDriver,
                                  phoneNumber: {
                                    ...newDriver.phoneNumber,
                                    country: val
                                  }
                                });
                              }
                            }}
                          />
                        </div>
                        {
                          phoneError !== "" ?
                            <span className={"field-error-message"}>{phoneError}</span>
                            : (meta.touched && meta.error) &&
                            <span className={"field-error-message"}>
                              {phoneError || "Phone number is required."}
                            </span>
                        }
                      </div>
                    );
                  }}
                </Field>
              </Grid>
              )}
              {visibilityMap.location && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{ paddingRight: "10px", marginTop: "20px" }}>
                <AddressPicker
                  fieldName="location"
                  required={requiredMap.location}
                  onChange={(address: IAddress) => {
                    if (address) {
                      setFieldValue("location", address)
                      setNewDriver({
                        ...newDriver,
                        location: address
                      });
                    }
                  }}
                />
              </Grid>
              )}
              <Grid item container xs={6} style={{ marginTop: "20px" }}>
                <Fab
                  className="blackBackButton"
                  variant="extended"
                  size="medium"
                  aria-label="Update"
                  onClick={(e) => {
                    setDocumentDialogVisible(true);
                  }}
                >
                  {t("root:upload").toUpperCase()} {getLocalisedLicense(country)} {t("root:image").toUpperCase()}
                </Fab>
                <Grid item>
                  <Typography variant="h4">
                    {t("root:uploadFrontBackLicence")}
                  </Typography>
                </Grid>
                <ErrorMessage
                  name="license.images"
                  component="div"
                >
                  {msg => <div className={"field-error-message"}>{msg}</div>}
                </ErrorMessage>
              </Grid>
              <Grid item container xs={12} style={{ marginTop: 20 }}>
                <Fab
                  variant="extended"
                  size="medium"
                  type="submit"
                  style={{ margin: '0 10px' }}
                  onClick={(e) => {
                    e.preventDefault();
                    submitForm();
                  }}
                  disabled={props.saveDriverLoading}
                >
                  {t("root:add")}
                </Fab>
                <Fab
                  variant="extended"
                  className="blackBackButton"
                  size="medium"
                  type="button"
                  onClick={(e) => props.openForm && props.openForm()}
                  style={{ margin: '0 10px' }}
                >
                  {t("misc:cancel")}

                </Fab>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>

      <div>
        <DragDropImages
          open={documentDialogVisible}
          handleCloseDragDrop={() => setDocumentDialogVisible(false)}
          handleSave={uploadDocument}
          deleteSelectedImage={onDeleteDriverImage}
          filesLimit={2}
          title={`${t("root:upload")} ${getLocalisedLicense(country)} ${t("root:images")}`}
        />
      </div>
    </Grid>
  )
}

export default AddNewDriver
